/* Form component to add extra crew members by department 
   These won't be on the Callsheet*/
import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../../../styles/Callsheets.module.css";
import btnStyles from "../../../styles/Button.module.css";
import ExtraCrewMember from "./ExtraCrewMember";
import Alert from "react-bootstrap/Alert";
import { axiosInstance, axiosReq } from "../../../api/axiosDefaults";
import { useCurrentUser } from "../../../contexts/CurrentUserContext";
import { CLIENT_PROGRAM_HOSTNAME } from "../../../utils/config";
import useHostName from "../../../hooks/useHostName";
import toast from "react-hot-toast";

const ExtraCrewInfo = (props) => {
  const host = useHostName();
  const [errors, setErrors] = useState({});
  const [crew, setCrew] = useState({ results: [] });
  const { setShow, dept } = props;
  console.log(props)

  const [postData, setPostData] = useState({
    name: "",
    position: "",
    email: "",
    phone: "",
  });

  const { name, position, email, phone } = postData;

  const handleChange = (event) => {
    setPostData({
      ...postData,
      [event.target.name]: event.target.value,
    });
  };

  const clear = () => {
    /* Function to clear values */
    setPostData({
      name: "",
      position: "",
      email: "",
      phone: "",
    });
  };

  /* function to fetch the extra crew */
  const handleMount = async () => {
    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        const { data } = await axiosReq.get(
          `/extracrewinfo/?departments=${dept}`
        );
        setCrew(data);
        console.log(data);
      } else {
        const { data } = await axiosInstance.get(
          `${localStorage.getItem(
            "projectSlug"
          )}/extracrewinfo/?departments=${dept}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        );
        setCrew(data);
        console.log(data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    handleMount();
    // eslint-disable-next-line
  }, [dept]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Email validation regex
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailPattern.test(email)) {
      toast.error(`Enter a valid email address`, {
        duration: 3000,
        position: "top-right",
      });
      return;
    }

    const formData = new FormData();
    formData.append("name", name);
    formData.append("position", position);
    formData.append("departments", dept);
    formData.append("email", email);
    formData.append("phone", phone);

    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        const { data } = await axiosReq.post("/extracrewinfo/", formData);
        toast.success(`Crew Info Updated`);
        setPostData({
          name: "",
          position: "",
          departments: "",
          email: "",
          phone: "",
        });
        setCrew((prevCrew) => ({
          ...prevCrew,
          results: [data, ...prevCrew.results],
        }));
      } else {
        const { data } = await axiosInstance.post(
          `${localStorage.getItem("projectSlug")}/extracrewinfo/`,
          formData,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        );
        toast.success(`Crew Info Updated Successfully!`);
        setPostData({
          name: "",
          position: "",
          departments: "",
          email: "",
          phone: "",
        });
        setCrew((prevCrew) => ({
          ...prevCrew,
          results: [data, ...prevCrew.results],
        }));
      }
    } catch (err) {
      console.log(err);
      if (err.response?.status !== 401) {
        setErrors(err.response?.data);
      }
    }
  };

  const buttons = (
    <div className="pb-3 text-center">
      <Button
        className={`${btnStyles.Button} ${btnStyles.Blue} px-3 px-md-5 mr-3`}
        onClick={clear}
      >
        Cancel
      </Button>
      <Button
        className={`px-3 px-md-5 ml-3 ${btnStyles.Button} ${btnStyles.Blue}`}
        type="submit"
      >
        Submit
      </Button>
    </div>
  );

  return (
    <div className={`${styles.White } mx-md-5`}>
    <div className="d-none d-md-block mt-4">
    <Row>
    <Col>
    <h5 className={`pl-5 py-1 text-center ${styles.SubTitle }`} 
        style={{ textTransform: 'uppercase' }}>
            NON-CALLSHEET EXTRA {dept} POSITIONS 
            <span className={`pt-1 float-right ${styles.Close }`} 
        onClick={() => setShow(false) } >Close</span>
    </h5>
    </Col>
    </Row>
    </div>
    <div className="d-block d-md-none mt-3">
    <Row>
    <Col xs={12} >
    <h5 className={`py-1 text-center ${styles.SubTitle }`} 
        style={{ textTransform: 'uppercase' }}>
            EXTRA {dept} POSITIONS
    </h5>
    </Col>
    </Row>
    <Row>
    <Col>
    <span className={`pt-1 float-right ${styles.Close }`} 
        onClick={() => setShow(false) } >Close</span>
    </Col>
    </Row>
    </div>
    {/* Form */}
    <div >
    <Row>
    <Col>
    <div className="d-flex justify-content-center">
    <p className={`text-center mt-3 ${styles.SubTitle4 }`}>ADD NEW POSITION</p>
    </div>
    </Col>
    </Row>
    <Form className={`text-center px-3`} onSubmit={handleSubmit}>
    <Row className="mx-0 my-3">
        <Col className="d-flex justify-content-center mx-0 px-0" xs={6} sm={6} lg={3} >
            <Form.Group controlId="position" className={`${styles.Width95} `}  >
                <Form.Label className={`${styles.BoldScene}`} >Position</Form.Label>
                <Form.Control 
                className={`${styles.Input}`} 
                type="text"
                name="position"
                value={position}
                onChange={handleChange}
                    />
            </Form.Group>
            {errors?.position?.map((message, idx) => (
              <Alert variant="warning" key={idx}>
                {message}
              </Alert>
            ))}
        </Col>
        <Col className="d-flex justify-content-center mx-0 px-0" xs={6} sm={6} lg={3} >
        <Form.Group controlId="name" className={`${styles.Width95} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Name</Form.Label>
              <Form.Control 
              className={`${styles.Input}`} 
              type="text"
              name="name"
              value={name}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.name?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
        </Col>
        <Col className=" d-flex justify-content-center mt-3 mt-lg-0 mx-0 px-1" xs={6} sm={6} lg={3}>
        <Form.Group controlId="phone" className={`${styles.Width95} `}  >
            <Form.Label className={`${styles.BoldScene}`} >Phone</Form.Label>
            <Form.Control 
            className={`${styles.Input}`} 
            type="text"
            name="phone"
            value={phone}
            onChange={handleChange}
                />
        </Form.Group>
        {errors?.phone?.map((message, idx) => (
          <Alert variant="warning" key={idx}>
            {message}
          </Alert>
        ))}
        </Col>
        <Col className="d-flex justify-content-center mt-3 mt-lg-0 mx-0 px-0" xs={6} sm={6} lg={3}>
        <Form.Group controlId="email" className={`${styles.Width95} `} >
        <Form.Label className={`${styles.BoldScene}`} >Email</Form.Label>
            <Form.Control 
            className={`${styles.Input}`} 
            type="text"
            name="email"
            value={email}
            onChange={handleChange}
                />
        </Form.Group>
        {errors?.email?.map((message, idx) => (
          <Alert variant="warning" key={idx}>
            {message}
          </Alert>
        ))}
        </Col>
    </Row>
      {buttons}
    </Form>
    </div>

      {/* crew */}
      <div className="text-center mt-3">
      <Row>
      <Col>
      <div className="d-flex justify-content-center">
      <p className={`text-center ${styles.SubTitle4 }`}>POSITIONS</p>
      </div>
      </Col>
      </Row>
      </div>
      <Row className="py-3">
        <Col xs={12}>
          {crew.results.length
            ? crew.results.map((crewone) => (
                <ExtraCrewMember
                  key={crewone.id}
                  {...crewone}
                  handleMount={handleMount}
                  crewone={crewone}
                />
              ))
            : ""}
        </Col>
      </Row>
      {/* Break2 */}
      <Row>
      <Col xs={{span: 8, offset: 2}} >
      <hr className={`${styles.Break2 }`}/>
      </Col>
      </Row>
    </div>
  );
};

export default ExtraCrewInfo;
